import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
// import numeral from 'numeral';
import LightBox from '@bd/bdui-lightbox';
import { css } from '@bd/bdui-styles/emotion';
import { GoogleMapUrl } from '@bd/bdcore-utilities';
import withData from '@bd/bdcore-data';
import { colors, typography } from '../../styles';

const styles = css`
  margin-bottom:100px;
  .Banner_Title {
    color:  white;
    font:700 18px/1 ${typography.SansSerif};
    padding:20px 30px;
    border:1px solid ${colors.color1};
    text-transform: uppercase;
    display: inline-block;
    margin-bottom: 24px;
    background: ${colors.color1};
    @media (min-width: 992px) {
      font:700 24px/1 ${typography.SansSerif};
    }
  }
  h2 {
    font:700 24px/1.4 ${typography.SansSerif};
    color:  ${colors.color1};
    display:block;
    width:100%;
    text-transform: capitalize;
    margin-bottom:30px;
  }
  .Banner_Body {
    font:400 16px/34px ${typography.SansSerif};
    color:  ${colors.color5};
    @media (min-width: 992px) {
      font:400 18px/40px ${typography.SansSerif};
    }
  }
  .linkLike {
    color:  ${colors.color1};
    cursor:pointer;
    transition: all .25s ease;
  }
  .linkLike:hover {
    color:  ${colors.color1Darkest};
    cursor:pointer;
  }
  .CommunityActions {
    padding-bottom:30px;
    li {
      padding:4px 0;
    }
  }
  .CommunityPrice {
    font-size: 36px;
    margin-bottom: 15px;
  }
`;

function CommunityDetailContent({ community, agent }) {
  return (
    <div className={styles}>
      <div className="container">
        <div className="row">
          <div className="col-lg-4">
            {
            get(community, 'description') &&
              <div className="Banner_Title">Description</div>
            }
            <ul className="list-unstyled CommunityActions">
              <li><li>{get(community, 'address.streetAddress')}<br />{get(community, 'address.addressLocality')}, {get(community, 'address.addressRegion')} {get(community, 'address.postalCode')}</li></li>
              <li><strong><a href={GoogleMapUrl(community)} target="_blank" rel="noopener noreferrer" className="linkLike"><img src="/images/icon-pin.svg" alt="" width="40" height="40" /> Google Map</a></strong></li>
              <li>
                <ul className="list-unstyled">
                  <li><strong>AGENT:</strong></li>
                  <li><strong>{get(agent, 'name')}</strong></li>
                </ul>
              </li>
              <li>
                {
                  get(community, 'photos').length > 0 &&
                    <LightBox
                      items={get(community, 'photos', [])}
                      button={(
                        <div className="btn">
                          <span>View All Photos</span>
                        </div>
                      )}
                    />
                }
              </li>
            </ul>
          </div>
          <div className="col-lg-8">
            {
              get(community, 'headline') &&
              <h2>{get(community, 'headline')}</h2>
            }
            {
              get(community, 'description') &&
              <span className="Banner_Body">{get(community, 'description')} <a href={`tel:${get(agent, 'telephone', '').replace(/[^0-9]/g, '')}`}>{agent.telephone}</a></span>
            }
          </div>
        </div>
      </div>
    </div>
  );
}

CommunityDetailContent.propTypes = {
  community: PropTypes.object.isRequired,
  agent: PropTypes.object.isRequired,
};

export default withData(
  {
    community: true,
    agent: true,
  },
  {
    required: {
      community: true,
      agent: true,
    },
  },
)(CommunityDetailContent);



// WEBPACK FOOTER //
// ./src/pages/CommunityDetail/ComDetailContent.js